import { Component } from 'react';

import { getState } from '../state/store';
import * as Authorization from './authorization';
import { isCoach, logout } from '../state/reducer/app/appState';

export default class CoachBounceRouteShim extends Component {
    componentWillMount() {
        const isAuthenticated = getState().auth.isAuthenticated;
        if (isAuthenticated && isCoach()) {
            window.location = Authorization.navigateToAthletes.path;
            return;
        }
        window.location = Authorization.navigateToAthleteWeb.path;
    }
    render() {
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/lib/CoachBounceRouteShim.jsx